export default __webpack_public_path__ + "static/box2-63753cbdf72589a22e3e5b27c8fee3a1.png";